module.exports = __webpack_public_path__ + "static/case-slide-2-27516a2d98ff2937d573465b08215a8c.jpg";